export const shipment = {
  shipment: {
    noShipmentsAvailable: 'No shipments available.',
    table: {
      header: {
				orderNumber: 'Order #',
				orderDate: 'Order Date',
				expShipDate: 'Exp. Ship Date',
				actualShipDate: 'Actual Ship Date',
				poNumber: 'PO #',
				tracking: 'Tracking #',
				invoiceNumber: 'Invoice #',
				partNumber: 'Part #',
				qtyOrdered: 'Qty Ordered',      
      },
    },
    form: {
			instructions: 'Use the fields below to search for shipments.',						
			orderDate: 'Order Date',
			showOnlyOpenOrders: 'Show only open orders',
			showOnlyDelayedShipments: 'Show only delayed shipments',
    },
  },
};
